module.exports = __webpack_public_path__ + "static/media/sinpas-finans-sehir-2-bed.4284614a.jpg";